import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';
import NavSidebar from '../Util/NavSidebar/NavSidebar';
import ProductItem from '../Util/ProductItem/ProductItem';
import {
  getProductList,
} from '../../redux/actions/product';
import {
  getBuyHistory,
} from '../../redux/actions/cart';

const keywords = ['TERRA', 'single', '単品'];

const Single = () => {
  const accessToken = useSelector((state) => state.auth.accessToken, shallowEqual);
  const isBuyProduct = useSelector((state) => state.cart.isBuyProduct, shallowEqual);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);
  const [productListView, setProductListView] = useState([]);
  const productList = useSelector((state) => state.product.productList, shallowEqual);
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getBuyHistory(accessToken, 1, 0));
    }
  }, [accessToken, dispatch, isLoggedIn]);

  useEffect(() => {
    dispatch(getProductList(Number(process.env.REACT_APP_COMPANY_ID), -1, 0));
  }, [dispatch]);

  useEffect(() => {
    if (isLoggedIn && isBuyProduct) {
      const filterProduct = productList.filter((p) => p.product_categories[0]?.category_name === '単品');
      setProductListView(filterProduct);
    } else {
      const filterProduct = productList.filter((p) => p.product_categories[0]?.category_name === '単品' && !p.name.includes('充用液剤'));
      setProductListView(filterProduct);
    }
  }, [productList, isLoggedIn, isBuyProduct]);

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>単品｜株式会社TERRA</title>
      </Helmet>
      <div className="subscriptions">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          単品
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>単品</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container">
          <div className="row">
            <div className="col-3 d-none d-lg-block p-0" style={{ background: 'white' }}>
              <NavSidebar />
            </div>
            <div className="col-12 col-lg-9">
              <div className="p-2">
                <div className="single-list row">
                  {
                    productListView.map((item) => (
                      <ProductItem
                        key={item.id}
                        id={item.id}
                        imgUrl={item.main_image}
                        type={item.type}
                        name={item.name}
                        price={item.price}
                        page="single"
                        isSubscription={false}
                        label
                      />
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};

export default Single;
